import Image from 'utils/images';
import InputGroup from 'components/Input/InputGroup'
import React, { Fragment } from 'react'
import { IoIosCloseCircleOutline, IoIosSearch } from "react-icons/io";
import { IoFilterSharp } from 'react-icons/io5'
import { updateFilterVisibility } from 'Slices/SuperAdmin/Jobs';
import SaJobApplicantsCard from 'components/Cards/SaJobApplicantsCard';
import { handlesaJobSearch, handleSortBy } from 'Actions/SuperAdmin/JobsAction';
import SaJobFilterWigdet from './SaJobFilterWigdet';

const ApplicantLeftContainer = ({
    glow, categoryChangingGlow,
    showFilterBox, sortBy,
    dispatch, candidatesList,
    candidatesListNoNMutable,
    jobId, candidate_job_role,
    search, seleced_filter_data,
    filter_parameters, pageRender
}) => {


    return (
        <Fragment>
            <div className="homePage-backgroundColor">
                <div className={`showing-results-zIndex homePage-backgroundColor pt-2 pt-lg-0 d-flex flex-wrap`}>
                    <div className="col-12 col-md-6 col-lg-12">
                        {glow || categoryChangingGlow ?
                            <div className="placeholder card rounded-3 border-0 w-100 py-3"></div>
                            :
                            <div className="card rounded-3 border-0">
                                <div className="card-body p-0 cursorPointer">
                                    <div
                                        className="row p-0 filter-closet py-2 px-3"
                                        onClick={() => dispatch(updateFilterVisibility(!showFilterBox))}
                                    >
                                        <div className="col"><p className="mb-0 fw-bold candidate-filter-tab-fs">Filter</p></div>
                                        <div className="col text-end">
                                            <IoFilterSharp id="applicantsFilterIcon" />
                                        </div>
                                    </div>

                                    <div className={`${showFilterBox ? "employer-filter-box rounded-4 filter-closet shadow" : "d-none"}`}>
                                        <div className="contner h-100">
                                            <div className="row align-items-center sticky-top p-3 pb-2 border-bottom bg-white start-0 end-0 top-0 bottom-0 w-100 rounded-top-4">
                                                <div className="col">
                                                    <h6 className="m-0 fw-bold">Filter</h6>
                                                </div>
                                                <div className="col text-end pe-0">
                                                    <button id="applicantsFilterCloseButton" className="btn btn-sm border-0">
                                                        <IoIosCloseCircleOutline
                                                            className="fs-4"
                                                            onClick={() => dispatch(updateFilterVisibility(!showFilterBox))}
                                                        />
                                                    </button>
                                                </div>
                                            </div>

                                            {/* employer-filter-box body */}
                                            <SaJobFilterWigdet
                                                seleced_filter_data={seleced_filter_data}
                                                filter_parameters={filter_parameters}
                                                jobId={jobId}
                                                dispatch={dispatch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {glow || categoryChangingGlow ?
                        <div className="placeholder w-100 py-3 rounded-3 mt-1"></div>
                        :
                        <div className="col-12 col-md-6 col-lg-12 mt-2 mt-md-0 mt-lg-2 ps-md-2 ps-lg-0">
                            <div className="d-flex position-relative">
                                <InputGroup className="home-search-icon fs-5" reIcons={<IoIosSearch />} />
                                <input
                                    type="text"
                                    className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                                    placeHolder="Search by name"
                                    ariaLabel="default input example"
                                    testId="searchResult"
                                    value={search}
                                    onChange={(e) => dispatch(handlesaJobSearch({ candidatesListNoNMutable: candidatesListNoNMutable, searchValue: e.target.value }))}
                                />
                            </div>
                        </div>
                    }

                    {glow || categoryChangingGlow ?
                        <div className="placeholder w-100 py-3 rounded-3 mt-1"></div>
                        :
                        <div className="container-lg">
                            <div className="row py-1 py-md-3 mt-2 mt-md-0 px-0 px-sm-1 align-items-center">
                                <div className="col-12 col-sm-6 col-lg-12 p-0">
                                    <div className="card border-0 rounded-3 w-100 px-2 bg-transparent p-0 mx-1">
                                        <div className="card-body showing-Persoon-content p-0">
                                            <div className="d-flex flex-wrap align-items-center employer-custom-dropdown">
                                                <div className="w-25 p-0">
                                                    <span className="w-100 fw-bold">Sort by:</span>
                                                </div>
                                                <div className="col">
                                                    <select className="form-select border-0" onChange={(e) => dispatch(handleSortBy({ sortBy: e.target.value, candidatesList: candidatesList, candidatesListNoNMutable: candidatesListNoNMutable }))} value={sortBy}>
                                                        <option selected>default</option>
                                                        <option value="A-Z">A-Z</option>
                                                        <option value="Z-A">Z-A</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 col-sm-6 col-lg-12 mt-1 ps-2 px-0">
                                    <p className="text-secondary showing-Persoon-content-applicant mb-0 pt-2">
                                        {
                                            candidatesList.length ?
                                                `Showing: 1-${candidatesList.length} of ${candidatesList.length} profiles`
                                                :
                                                'Showing: 0 profiles'
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className={`row align-content-start gy-2 ${glow || categoryChangingGlow ? 'px-3' : ''} overflow-scroll applicant_left_side_container`} style={{ height: glow || categoryChangingGlow ? '44rem' : '' }}>
                    {glow || categoryChangingGlow ?
                        Array.from({ length: 10 }).map((_, i) => {
                            return <div className="col-12 col-sm-6 col-lg-12 cursorPointer p-2 p-lg-0 pt-lg-2" key={i}>
                                <div className="card border-0 rounded-3">
                                    <div className="card-body">
                                        <div className="row align-items-center pt-3">
                                            {/* card image  */}
                                            <div className="col-4">
                                                <img src={""} alt="..." width={83} height={83} className='pe-none placeholder rounded-circle' />
                                            </div>

                                            {/* card content  */}
                                            <div className="col-8 px-1 pt-lg-3 pt-xl-0">
                                                <div className="col-12">
                                                    <p className="mb-0 employer-card-candidate-name placeholder w-75 py-3 rounded-1"></p>
                                                    <div className="pt-2">
                                                        <p className="mb-0 employer-card-candidate-name placeholder w-100 pt-2 pb-3 mb-1 rounded-1"></p>
                                                        <p className="mb-0 employer-card-candidate-name placeholder w-100 pt-2 pb-3 rounded-1"></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                        :
                        candidatesList.length > 0 ?
                            candidatesList.map((v, i) => {
                                return <React.Fragment key={i}>
                                    <SaJobApplicantsCard candidates_card={v} candidate_job_role={candidate_job_role} applicationStatus={v.recommended_by} dispatch={dispatch} jobId={jobId} professionalId={v?.professional_id} pageRender={pageRender} />
                                </React.Fragment>
                            })
                            :
                            <div className="sa_job_candidates_list_height w-100 d-inline-flex align-items-center justify-content-center">
                                <img src={Image.noRecordsFound} width={200} alt="logo" />
                            </div>
                    }
                </div>
            </div>
        </Fragment >
    )
}

export default ApplicantLeftContainer